import styles from './styles/Switch.module.scss';
import cn from 'classnames';

export default function Switch<ValueType extends string>({
  options,
  value,
  onChange,
  full,
  className
}: {
  options: ValueType[];
  value: ValueType;
  onChange: (value: ValueType) => void;
  full?: boolean;
  className?: string;
}) {
  function handleChange(v: ValueType) {
    if (v !== value) onChange(v);
  }

  return (
    <div className={cn(styles.Switch, { [styles.Full]: full }, className)}>
      {options.map(option => (
        <div key={option} className={cn(styles.Item, { [styles.Selected]: option === value })} onClick={() => handleChange(option)}>
          {option}
        </div>
      ))}
    </div>
  );
}
